var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';

var Warning = function Warning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "Warning_a",
    d: "M444.26 289h-18.52c-.95 0-1.82-.49-2.33-1.3a2.72 2.72 0 0 1-.12-2.67l9.26-18.51A2.73 2.73 0 0 1 435 265c1.05 0 1.99.58 2.46 1.52l9.25 18.51c.43.86.39 1.86-.12 2.67-.5.81-1.37 1.3-2.33 1.3M435 266.44c-.5 0-.94.27-1.16.72l-9.26 18.52c-.2.4-.19.87.06 1.26.24.4.64.62 1.1.62h18.52c.46 0 .87-.22 1.1-.62.25-.39.27-.85.07-1.26l-9.26-18.52a1.28 1.28 0 0 0-1.17-.72"
  }), React.createElement("path", {
    id: "Warning_b",
    d: "M435 284.52a1.3 1.3 0 1 1 0-2.6 1.3 1.3 0 0 1 0 2.6"
  }), React.createElement("path", {
    id: "Warning_c",
    d: "M436.29 272.96l-.52 6.28a.78.78 0 0 1-.77.72.78.78 0 0 1-.77-.72l-.53-6.28h.01l-.01-.11a1.3 1.3 0 0 1 2.6 0l-.01.1"
  })), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Warning_a",
    transform: "translate(-423 -265)"
  }), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Warning_b",
    transform: "translate(-423 -265)"
  }), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Warning_c",
    transform: "translate(-423 -265)"
  }));
};

export default Warning;